import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { ReconocimientoObj } from '../_modules/reconocimientos/models/reconocimiento-obj';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { shareReplay, map, catchError, concatMap } from 'rxjs/operators';

const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class ReconocimientosService {

  reconocimientos$ = this.getReconocimientos(0, false).pipe(
    shareReplay(1)
  );

  constructor(private http: HttpClient) { }

  getReconocimientos(id = 0, incluyeDesc = false, idPeriodo = 0, all = false): Observable<Array<
    {categoria: string, categoriaDisplay: string, alumnoId: number, reconocimientos: ReconocimientoObj[]}>> {
    return this.http.get<Array<{categoria: string, categoriaDisplay: string, alumnoId: number, reconocimientos: ReconocimientoObj[]}>>(
      // TODO: revertir
      `${API_URL}/api/Reconocimientos/alumno/${id}/desc/${incluyeDesc}/periodo/${idPeriodo}/all/${all}`);
      // `${API_URL}/api/Reconocimientos/alumno/${id}/desc/${incluyeDesc}/periodo/${idPeriodo}`);
  }

  pdfReconocimiento(obj: ReconocimientoObj) {
    // URL
    return this.http.post(`${API_URL}/api/Reconocimientos/pdf`,
      obj,
      {headers: {'Content-Type': 'application/json'}, responseType: 'blob'})
      .pipe(map(res => {
        return res;
      }));
  }

}
